@let userPlan = accessService.userPlan | async;
@let searchQuery = (menuSearchService.searchQuery$ | async);
@let effectiveActiveMenuGroup = searchQuery ? ALL_DATA_GROUP : activeMenuGroup;

<div
  class="layout"
  [class.opened]="menuService.isMenuOpened"
  [class.vertical]="isMobile"
  [class.horizontal]="!isMobile"
>
  <app-sidenav
    class="sidenav"
    [orientation]="isMobile ? 'vertical' : 'horizontal'"
    [(opened)]="menuService.isMenuOpened"
    (closed)="onSidenavClosed()"
  >
    <app-map-menu
      class="map-menu"
      [activeMenuGroup]="effectiveActiveMenuGroup"
      (closeRightMenu)="toggleRightMenu()"
    ></app-map-menu>
  </app-sidenav>

  <div class="content">
    <button (click)="toggleRightMenu()" class="right-menu-close-btn">
      <div class="right-menu-close-btn-container">
        <img
          class="right-menu-close-btn-arrow"
          alt="open/close map demography layers menu"
          [ngClass]="{ 'closed': !menuService.isMenuOpened }"
          src="../../assets/icons/rightMenuCloseBtn.svg"
        />
      </div>
    </button>

    <div class="groups-buttons-container-desktop">

      <button (click)="changeMenuGroup(ALL_DATA_GROUP); openRightMenu(); handleChartsGroupClick()"
              aria-label="Open menu"
              [ngClass]="effectiveActiveMenuGroup === ALL_DATA_GROUP ? 'active' : ''" class="allDataGroup"
              data-cy="all-data-menu-button">
<!--        <app-icon svgIcon="pointsGroup"></app-icon>-->
        All
      </button>

      <button (click)="changeMenuGroup(MAPS_GROUP); openRightMenu()"
              aria-label="Open data menu"
              [ngClass]="effectiveActiveMenuGroup === MAPS_GROUP ? 'active' : ''" class="indexesGroup">
<!--        <app-icon svgIcon="indexesGroup"></app-icon>-->
        Maps
      </button>
      <button (click)="changeMenuGroup(CHARTS_GROUP); openRightMenu(); handleChartsGroupClick()"
              aria-label="Open demographic charts menu"
              [ngClass]="effectiveActiveMenuGroup === CHARTS_GROUP ? 'active' : ''" class="chartsGroup"
              data-cy="charts-menu-button"
      >
<!--        <app-icon svgIcon="chartsGroup"></app-icon>-->
        Charts
      </button>
      <button (click)="changeMenuGroup(PLACES_GROUP); openRightMenu(); handleChartsGroupClick()"
              aria-label="Open places and points of interests menu"
              [ngClass]="effectiveActiveMenuGroup === PLACES_GROUP ? 'active' : ''" class="lensesGroup"
              data-cy="places-menu-button">
<!--        <app-icon svgIcon="pointsGroup"></app-icon>-->
        Places
      </button>
    </div>

    <app-favorites *ngIf="isMobile && !accessService.getIsUnauthorized()"
                   class="favorites"
                   [isFavoritesVisible]="isFavoritesVisible"
                   (closeFavorites)="handleFavoritesClose()"
                   (openFavorites)="handleFavoritesOpen()"
    ></app-favorites>

    <app-map-search
      [isSearchInputActive]="isSearchInputActive"
      (searchOpen)="handleSearchOpen()"
      (searchClose)="handleSearchClose()"
    ></app-map-search>

    <div class="map-tools-container"
         [ngClass]="isSearchInputActive ? 'selection-while-search-active' : ''">
      <app-favorites *ngIf="!isMobile && !accessService.getIsUnauthorized() && userHasPaidPlan()"
                     [isFavoritesVisible]="isFavoritesVisible"
                     (closeFavorites)="handleFavoritesClose()"
                     (openFavorites)="handleFavoritesOpen()"
      ></app-favorites>
      <app-level-selection *ngIf="!isMobile"></app-level-selection>
      <app-selection-tool
        *ngIf="!showToolsMobile &&
          ((accessService.isUserPlanUpdated | async) && accessService.getIsAdmin() ||
            userPlan === SubscriptionPlans.ENTERPRISE)
        "
      ></app-selection-tool>
      <app-multiple-features-selection *ngIf="userHasPaidPlan() && !isMobile"></app-multiple-features-selection>
    </div>

    <app-common-colorscale [currentLayer]="(layerStore.activeLayer | async)! | LayerNameFormatPipe:userPlan"
                           [isMobile]="isMobile"
                           (openMenuMobile)="toggleRightMenu()"
    ></app-common-colorscale>

    <app-mapbox></app-mapbox>
  </div>
</div>
